import React, { useEffect } from "react";
import HighlightImage from "../Home/HighlightPhoto.png"; // adjust path if needed

export default function HighlightPhoto() {
  useEffect(() => {
    const initAOS = async () => {
      try {
        const AOS = (await import('https://cdn.jsdelivr.net/npm/aos@2.3.4/dist/aos.js')).default;
        if (AOS && typeof AOS.init === 'function') {
          AOS.init({ 
            duration: 800,
            once: true,
            easing: 'ease-out-cubic'
          });
        }
      } catch (error) {
        console.log('AOS loading skipped');
      }
    };
    initAOS();
    
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/aos@2.3.4/dist/aos.css';
    document.head.appendChild(link);
  }, []);

  return (
    <section className="w-full flex max-w-5xl mx-auto justify-center  px-2">
      <div className="max-w-6xl w-full" data-aos="zoom-in" data-aos-delay="200">
        <img
          src={HighlightImage}
          alt="Highlight Section"
          className="w-full rounded-sm object-cover"
        />
      </div>
    </section>
  );
}